import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_bottom_pop_up_switcher = _resolveComponent("app-bottom-pop-up-switcher")!
  const _component_app_create_folder_pop_up = _resolveComponent("app-create-folder-pop-up")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_app_footer = _resolveComponent("app-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_app_quota_warning = _resolveComponent("app-quota-warning")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mainStore.isMobile)
      ? (_openBlock(), _createBlock(_component_el_container, {
          key: 0,
          direction: "vertical",
          class: _normalizeClass(["app-wrapper", {
      'app-wrapper--footer': !_ctx.hideFooter,
      'app-wrapper--open-keyboard': _ctx.openKeyboard,
      'android': _ctx.isAndroid,
    }])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, {
              class: _normalizeClass({manualScroll: _ctx.manualScroll})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view),
                _createVNode(_component_app_bottom_pop_up_switcher),
                (_ctx.mainStore.createFolderPopUp)
                  ? (_openBlock(), _createBlock(_component_app_create_folder_pop_up, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]),
            (!_ctx.hideFooter)
              ? (_openBlock(), _createBlock(_component_app_footer, {
                  key: 0,
                  onOpenMenu: _ctx.handleOpenMenu
                }, null, 8, ["onOpenMenu"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (!_ctx.mainStore.isMobile)
      ? (_openBlock(), _createBlock(_component_el_container, {
          key: 1,
          class: "desktop"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component }) => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ]),
              _: 1
            }),
            _createVNode(_component_app_bottom_pop_up_switcher)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.quotaWarningText)
      ? (_openBlock(), _createBlock(_component_el_container, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_app_quota_warning, { onOnClose: _ctx.closeQuotaWarning }, {
              text: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.quotaWarningText), 1)
              ]),
              _: 1
            }, 8, ["onOnClose"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}